export default "__VITE_ASSET__BYu$krw9__"